<script>
export default {
  props: ['item'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {

  },
  created() {

  },
  methods: {
    submit_form() {
      this.$emit('curpage');
    }
  }
}
</script>

<template>

  <div class="_w-m-1000 mx-auto my-5">
    <form @submit.prevent="submit_form()">
      <div class="text-center mb-5">
        <img :src="formatImage('/fm/revinre-nc/clip art/Order history.png')" class="_w-m-300" data-aos="fade-zoom-in">
        <h3 class="mb-3" data-aos="fade-zoom-in">Order history</h3>
        <p class="text-muted" data-aos="fade-zoom-in">Below is a record of purchases made on this listing.</p>
      </div>

      <div v-for="(cart, cart_i) in item.carts" :key="cart.id" class="">
        <w-invoice :item="cart"></w-invoice>
      </div>

      <div class="row py-5">
        <div class="col-6">
          <button type="submit" class="btn btn-lg btn-success" :disabled="loading"><Icon icon="ri:arrow-left-double-fill" /> Previous</button>
        </div>
        <div class="col-6 text-right">

        </div>
      </div>
    </form>
  </div>

</template>
